import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';
import Icon from '@material-ui/core/Icon';
import * as Constants from '../../common/constants';
import Divider from '@material-ui/core/Divider';
export const PaperWithTitle = (props) => {
    const { t } = useTranslation();
    const { title, titleAlign = 'left', titleIcon, titleButton, children } = props;
    return (React.createElement(SPaper, { elevation: 2 },
        React.createElement(SPaperTitleArea, { align: titleAlign },
            titleIcon && React.createElement(SCircleIcon, null, titleIcon),
            React.createElement(SPaperTitle, null, t(title)),
            titleButton && React.createElement(SButtonArea, null, titleButton)),
        React.createElement(SDivider, null),
        children));
};
const SPaper = styled(Paper) `
  padding: 12px;
`;
const SPaperTitleArea = styled.div `
  display: flex;
  align-items: center;
  justify-content: ${({ align }) => align === 'center' && 'center'};
  padding-bottom: 8px;
`;
const SCircleIcon = styled(Icon) `
  margin-right: 12px;
  padding: 6px;
  background-color: ${Constants.COLOR.ORANGE700};
  color: #fff;
  border-radius: 50%;
`;
const SPaperTitle = styled.p `
  margin: 0;
  font-size: 18px;
  font-weight: bold;
`;
const SDivider = styled(Divider) `
  margin-bottom: 16px;
`;
const SButtonArea = styled.div `
  margin-left: auto;
`;
